import * as React from "react"
import { cn } from "@/infrastructure/lib/utils"
import { X } from "lucide-react"
import { Button } from "./button"

interface FlyoutProps extends React.HTMLAttributes<HTMLDivElement> {
  open?: boolean
  onClose?: () => void
  children: React.ReactNode
}

export function Flyout({ open, onClose, children, className, ...props }: FlyoutProps) {
  return (
    <>
      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50"
          onClick={onClose}
        />
      )}
      
      {/* Flyout panel */}
      <div
        className={cn(
          "fixed top-0 right-0 h-full bg-background/95 border-l shadow-lg z-50 transform transition-transform duration-300 ease-in-out backdrop-blur-sm",
          "w-[40vw] md:w-[40vw] sm:w-full",
          open ? "translate-x-0" : "translate-x-full",
          className
        )}
        {...props}
      >
        <div className="flex flex-col h-full">
          <div className="flex justify-end p-1 relative z-[100]">
            <Button 
              variant="ghost" 
              size="sm"
              className="h-8 w-8 hover:bg-muted rounded-full"
              onClick={(e) => {
                e.stopPropagation();
                onClose?.();
              }}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <div className="flex-1 overflow-y-auto px-6 -mt-6">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}
